export function etaInMinutes(toTime?: number | string) {
    if (toTime == null) {
        return null;
    }
    return Math.round((new Date(toTime).getTime() - new Date().getTime()) / 1000 / 60);
}

export function delayInMinutes(time?: number | string) {
    if (time == null) {
        return null;
    }
    return Math.abs(Math.ceil((new Date(time).getTime() - new Date().getTime()) / 1000 / 60));
}
